<template>
  <el-dialog title="术语替换" :visible.sync="dialogVisible_" width="30%" :close-on-click-modal="false"
             :show-close="false" :close-on-press-escape="false" style="text-align:center"
             top="40vh">
    <div class="line"></div>
    <div class="content_wrap">
      <span>术语已经成功添加到项目术语库，正在替换和重译所有未确认的句段...</span>
      <i class="loading_gif"></i>
    </div>
    <span slot="footer" class="dialog-footer">
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "termDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
    };
  },
  computed: {
    dialogVisible_: function () {
      return this.dialogVisible;
    },
  },

};
</script>
<style lang="less" scoped>
/deep/.el-dialog {
  border-radius: 5px;
  .line {
    height: 1px;
    background: rgba(228, 228, 228, 1);
    margin-bottom: 40px;
  }

  .el-dialog__body {
    padding-top: 5px;
    .content_wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      .loading_gif {
        display: inline-block;
        vertical-align: middle;
        margin-top: 40px;
        width: 30px;
        height: 30px;
        background: url("~@/assets/imgs/editor/loading_gif.gif") no-repeat;
        background-size: cover;
      }
    }
  }
}
</style>
